import { register } from '!/repository'
import { nay, T } from '@/helpers'
import { api } from '@setplex/tria-api'
import { createEvent, restore, sample } from 'effector'
import { not } from 'patronum'
import { model as tvBundlesModel } from '~/entities/tv/bundles'
import { model as paymentModel } from '~/features/payment/generic'
import { updateTvChannel } from '~/routes/tv/root/model'
import { genPagesLogicNew } from '~/shared/effector'

export const initTvBundlePage = createEvent<{
  bundleId: number
  query: URLSearchParams
}>()
export const left = createEvent()

/** Skeleton start*/
export const setContentLoading = createEvent<boolean>()

export const $contentLoading = restore(setContentLoading, false)

/** Skeleton end*/

export const loadMoreTvBundleContent = genPagesLogicNew(
  api.tvBundles.$tvBundleWithContentPageInfo,
  api.tvBundles.paginateTvBundleWithContent
)

sample({
  clock: initTvBundlePage,
  filter: not(api.tvBundles.loadTvBundleWithContentFx.pending),
  fn: (clockData) => ({ ...clockData, page: 0 }),
  target: api.tvBundles.loadTvBundleWithContentFx,
})

/********** Skeleton logics starts ***********/
sample({
  clock: initTvBundlePage,
  fn: T,
  target: setContentLoading,
})

sample({
  clock: api.tvBundles.loadTvBundleWithContentFx.pending,
  filter: nay,
  target: setContentLoading,
})

/********** Skeleton logics ends ***********/

// clear paginatable stores
api.tvBundles.$tvBundleWithContent.reset(initTvBundlePage)

register(loadMoreTvBundleContent, 'loadMoreTvBundleContent')
register(
  tvBundlesModel.$tvBundleWithContentFormatted,
  '$tvBundleWithContentFormatted'
)
register(
  paymentModel.selectTvBundlePaymentButton,
  'selectTvBundlePaymentButton'
)
register(paymentModel.selectTvChannel, 'selectTvChannel')
register(updateTvChannel, 'updateTvChannel')
